var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.TL=require("moment");module.exports=$CLJS.TL;